'use client'

import { Inbox } from 'lucide-react'
import { Button } from '@/components/ui/shadcn/button'

export default function Empty({
  title,
  description,
  action,
  actionText,
  actions,
  alert,
  style,
}) {
  return (
    <div
      className="flex flex-1 flex-col items-center justify-center py-16 text-center"
      style={style}
    >
      <div className="flex size-12 items-center justify-center rounded-full bg-muted">
        <Inbox className="size-6 text-muted-foreground" />
      </div>
      <h3 className="mt-4 text-lg font-semibold">{title}</h3>
      <p className="mt-1 max-w-sm text-sm text-muted-foreground">
        {description}
      </p>
      {alert && (
        <div className="mt-4 max-w-sm rounded-md border border-border bg-muted/50 px-4 py-3 text-left text-sm text-muted-foreground">
          {alert}
        </div>
      )}
      {action && (
        <Button onClick={action} className="mt-4">
          {actionText}
        </Button>
      )}
      {actions && <div className="mt-4">{actions}</div>}
    </div>
  )
}
